
export const doNotForwardProps= (...props: string[]) => ({
    shouldForwardProp: (prop: string) => !props.includes(prop)
})
